import Select from "@/components/Select";
import React, { useMemo } from "react";
import { Comparator, comparatorDefs, SerializedCondition } from "../types";
import ReactSelect, { SingleValue } from "react-select";
import { languageOptions } from "@/constants/languages";

export type LanguageCondition = {
  language: string;
  comparator: Comparator;
};

export function LanguageEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const languageCondition = JSON.parse(
    condition.data || "{}"
  ) as LanguageCondition;

  const languageSelectOptions = useMemo(() => {
    return Object.keys(languageOptions).map((key) => ({
      value: key,
      label: key
    }));
  }, []);

  const selectedLanguage = useMemo(() => {
    if (!languageCondition.language) return null;
    return {
      value: languageCondition.language,
      label: languageCondition.language
    };
  }, [languageCondition.language]);

  function update(data: LanguageCondition) {
    onUpdate({ ...condition, data: JSON.stringify(data) });
  }

  function updateLanguage(
    selectedOption: SingleValue<{ label: string; value: string }>
  ) {
    update({
      ...languageCondition,
      language: selectedOption?.value || ""
    });
  }

  const validComparatorOptions: Record<string, string> = {
    equals: comparatorDefs.equals,
    notEquals: comparatorDefs.notEquals,
    exists: comparatorDefs.exists,
    notExists: comparatorDefs.notExists
  };

  return (
    <>
      <Select
        options={validComparatorOptions}
        value={languageCondition.comparator}
        onChange={(v) => update({ ...languageCondition, comparator: v })}
      />
      {languageCondition.comparator !== "exists" &&
        languageCondition.comparator !== "notExists" && (
          <ReactSelect
            name="language"
            options={languageSelectOptions}
            value={selectedLanguage}
            className="basic-select w-full"
            classNamePrefix="select"
            onChange={(e) => updateLanguage(e)}
            placeholder="Select language..."
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "40px",
                height: "40px",
                borderRadius: "0.375rem",
                borderColor: "#d1d5db",
                cursor: "pointer"
              }),
              valueContainer: (base) => ({
                ...base,
                height: "40px",
                padding: "0 8px"
              }),
              input: (base) => ({
                ...base,
                margin: "0",
                padding: "0"
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: "40px"
              })
            }}
          />
        )}
    </>
  );
}
